export const errors = {
  NO_LOCATION_ERROR: 'Please fill in the address input to continue.',
  LOCATION_ACCESS_ERROR:
    'We could not detect your current location. Make sure you enable location access in your browser and try again.',
  NO_TERMS_ERROR: 'Please confirm that you agree to our Privacy Policy before continuing.',
  SAVE_ERROR: 'There was an error saving your address! Please try again later.'
};

export const warnings = {
  NOT_ENOUGH_DATA:
    'Please note that the speed test will be counted against your current data plan which may have a data cap.',
};

export const capitalize = word => {
  return word.charAt(0).toUpperCase() + word.slice(1);
}